<template>
    <dx-grid
        :url="url"
        :columns="columns"
        :title="title"
        :actions="actions"
        :onRowClicked="onRowClicked"
        navigationPath="onRowClicked"
        navigationField="onRowClicked"
        :beforeSetupGrid="beforeSetupGrid"
        ref="grid"
    ></dx-grid>
</template>

<script>
export default {
    data: () => ({
        title: "Classes",
        columns: [
            {
                sortable: false,
                label: "Reg ID",
                field: "regID",
                hidden: true,
                filterOptions: {
                    enabled: true,
                    filterValue: "LP" + new Date().getFullYear(),
                },
            },
            {
                sortable: true,
                label: "Class Type",
                field: "classType",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "Grade",
                field: "grade",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Class Name",
                field: "className",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Teacher",
                field: "teacher",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Building",
                field: "building",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Room Number",
                field: "roomNum",
                type: "number",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
        ],
        actions: [],

        regID: "",
        url: "",
    }),
    async created() {},
    methods: {
        async beforeSetupGrid() {
            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms.map((t) => t.term),
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.actions.push({
                text: "Add Class",
                action: this.addClass,
            });

            this.url = "classSetup?regID=" + this.regID;
        },
        async getTerms() {
            return await this.$http.get("api/lapidusDayCamp/getRegTerms");
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/lapidusDayCamp/getRegID");
        },
        async onRowClicked(row) {
            this.$router.push({
                name: "LapidusAddClass",
                params: { id: row.classID },
            });
        },
        addClass() {
            this.$router.push({
                name: "LapidusAddClass",
            });
        },
        onTermSelected(value) {
            this.regID = value;
            this.url = "classSetup?regID=" + this.regID;

            this.$refs.grid.reloadDataSource(this.url);
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
</style>
